query GetCharityChariotDisbursements($id: ID!) {
  charity(id: $id) {
    id
    chariotDisbursements {
      id
      status
      chariotId
    }
  }
}
